import { FIQAssist } from "../app"
import { Injectable, Inject } from "@fiqas/angular-utils"
import { LogListener, LogMessage } from "./logService"
@Injectable({
    module: FIQAssist,
    selector: NgLogListener.selector
})
export class NgLogListener implements LogListener {
    public static selector: string = "ngLogListener";
    constructor(
        @Inject('$log') private ngLogService: ng.ILogService
    ) {

    }
    public onDebug(message: LogMessage): void {
        this.ngLogService.debug(`${message.source}:${message.message}${(message.error ? ` error:${JSON.stringify(message.error)}` : "")}`);
    }
    public onInfo(message: LogMessage): void {
        this.ngLogService.info(`${message.source}:${message.message}${(message.error ? ` error:${JSON.stringify(message.error)}` : "")}`);
    }
    public onWarning(message: LogMessage): void {
        this.ngLogService.warn(`${message.source}:${message.message}${(message.error ? ` error:${JSON.stringify(message.error)}` : "")}`);
    }
    public onError(message: LogMessage): void {
        this.ngLogService.error(`${message.source}:${message.message}${(message.error ? ` error:${JSON.stringify(message.error)}` : "")}`);
    }
    public onAny(message: LogMessage): void {

    }
}
